import React, {useContext, useEffect, useState} from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import GreenCheckmarkWithTooltip from "./GreenCheckMarkWithTooltip";
import RedCrossWithTooltip from "./RedCrossWithTooltip";
import YellowBulbWithTooltip from "./YellowBulbWithTooltip";
import RedAlertWithTooltip from "./RedAlertWithTooltip";
import AuditContext from "../../store/audit-store";
import RosterStatsRow from "./RosterStatsRow";
import { INVALID_STATUS, STATUS_TEXT_RED, ROW_COLOR_RED } from "../../constants";
import { resolveShiftStatus, statusColorClasses } from "./shiftStatus";

// Re-exported for existing callers/tests that import these from AuditStatsRow; the implementations
// now live in shiftStatus so the CH Overall tab badge shares the same single source of truth.
export { findSelectedPlanGroup, resolveShiftStatus } from "./shiftStatus";

export default function AuditStatsRow() {
  const auditContext = useContext(AuditContext);
  const { auditStats, planGroups, selectedPlanGroupId, rosterIdList, currentRosterId } = auditContext;
  const { kioskScannedCount,
    kioskUnScannedCount,
    kioskLaborTrackCount,
    kioskNonLaborTrackCount,
    midShiftScannedCount,
    midShiftLaborTrackCount,
    midShiftNonLaborTrackCount
  } = auditStats

  const [status, setStatus] = useState(INVALID_STATUS);
  const [textClass, setTextClass] = useState(STATUS_TEXT_RED);
  const [rowClass, setRowClass] = useState(ROW_COLOR_RED);
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');

  useEffect(() => {
    const resolved = resolveShiftStatus(planGroups, selectedPlanGroupId, rosterIdList, currentRosterId)
    if (resolved === undefined || !resolved.status) {
      setStatus(INVALID_STATUS)
      setTextClass(STATUS_TEXT_RED)
      setRowClass(ROW_COLOR_RED)
      setStartTime('')
      setEndTime('')
    } else {
      const { textClass, rowClass } = statusColorClasses(resolved.status)
      setStatus(resolved.status)
      setStartTime(resolved.startTime ?? '')
      setEndTime(resolved.endTime ?? '')
      setTextClass(textClass)
      setRowClass(rowClass)
    }
  }, [planGroups, selectedPlanGroupId, rosterIdList, currentRosterId])

  // TODO: can refactor to auto-generate from objects
  return <Row spacing="medium large" className={rowClass} widths={["30%","40%","30%"]}>
    <Column>
      <Row spacing="medium medium" alignmentHorizontal="center">
        <Row spacing="small">
          <GreenCheckmarkWithTooltip tooltipText="#Badged In" /><Text type="h300">{kioskScannedCount} |</Text>
        </Row>
        <Row spacing="small">
          <RedCrossWithTooltip /><Text type="h300"> {kioskUnScannedCount} | </Text>
        </Row>
        <Row spacing="small">
          <YellowBulbWithTooltip tooltipText="#Auto Labor Tracked" /><Text type="h300"> {kioskLaborTrackCount} |</Text>
        </Row>
        <Row spacing="small">
          <RedAlertWithTooltip tooltipText="#Not Auto Labor Tracked" /><Text type="h300"> {kioskNonLaborTrackCount}</Text>
        </Row>
      </Row>
      <Row alignmentHorizontal="center">
        <Text>Kiosk Scans</Text>
      </Row>
    </Column>
    <RosterStatsRow status={status} startTime={startTime} endTime={endTime} textClass={textClass}/>
    <Column>
      <Row spacing="medium medium" alignmentHorizontal="center">
        <Row spacing="small">
          <GreenCheckmarkWithTooltip tooltipText="#Mid-Shift Moves" /><Text type="h300"> {midShiftScannedCount} |</Text>
        </Row>
        <Row spacing="small">
          <YellowBulbWithTooltip tooltipText="#Manual Labor Tracked" /><Text type="h300"> {midShiftLaborTrackCount} |</Text>
        </Row>
        <Row spacing="small">
          <RedAlertWithTooltip tooltipText="#Not Manual Labor Tracked" /><Text type="h300"> {midShiftNonLaborTrackCount}</Text>
        </Row>
      </Row>
      <Row alignmentHorizontal="center">
        <Text>Manual Labor Track Scans</Text>
      </Row>
    </Column>
  </Row>
}